
import { Component } from 'vue-property-decorator';
import ElementBase from './ElementBase';
import ElementConfiguration, { ClassMap, StyleMap } from '../configuration/ElementConfiguration';
import ChildrenListElementConfiguration from '../configuration/ChildrenListElementConfiguration';
import allComponents, { fixComponents, getComponentName } from './components';

@Component({
  name: 'Column',
  components: allComponents,
})
export default class Column extends ElementBase {
  getComponentName = getComponentName;

  get childrenConfiguration(): ChildrenListElementConfiguration {
    return this.configuration as ChildrenListElementConfiguration;
  }

  get children(): ElementConfiguration[] {
    return this.childrenConfiguration.children ?? [];
  }

  get growth(): number[] {
    const ret = this.childrenConfiguration.growth ?? [];
    //creates [0, ...., 0] with length: this.items.length - ret.length
    ret.push(...[...Array(Math.max(0, this.children.length - ret.length))].map(_ => 0));
    return ret;
  }
  
  beforeCreate(): void {
    fixComponents(this);
  }

  public onInformationPush(elementPath: string, json: string): void {
    super.onInformationPush(elementPath, json);
    const refs = this.$refs.element as (ElementBase[] | ElementBase);
    const elements = Array.isArray(refs) ? refs : [refs];
    elements.forEach(e => e.onInformationPush(elementPath, json));
  }

  protected defaultClass(): ClassMap {
    return Object.assign({}, super.defaultClass(), { 'd-flex': true, 'flex-column': true });
  }

  protected defaultStyle(): StyleMap {
    return Object.assign({}, super.defaultStyle(), { 'max-height': '100%' });
  }
}
